<template>
  <div class="details">
    <!-- <v-btn fab bottom right fixed color="primary" :loading="esvLoading" @click="putEsvUpdate" v-if="!readonly && $able('Save', 'ESV', esv)">
        <v-icon>
            save
        </v-icon>
    </v-btn> -->

    <v-card class="ma-sm-3" outlined>
      <tab-header :esv="esv" :readonly="readonly" :lockLoading="lockLoading || editModeLoading" 
                  :isConfirmingTabChange="isConfirmingTabChange" @edit="edit">
        <template #append-title>
          <span>
            <v-btn color="success" class="mr-2" small v-if="$can('ExportToPdf', esv)" @click="downloadDetails"
              :loading="downloadDetailsLoading">
              <v-icon left>mdi-export</v-icon>
              Export to PDF
            </v-btn>
            <v-btn color="success" class="mr-2" small v-if="$can('ExportModelsAndParts', esv)"
              @click="downloadModelsAndParts" :loading="downloadModelsAndPartsLoading">
              <v-icon left>mdi-export</v-icon>
              Export Models & Parts to Excel
            </v-btn>
            <v-btn outlined small v-if="$can('Copy', esv) && (!readonly || !$can('Edit', esv))" @click="routeToCopy">
              <v-icon left>mdi-content-copy</v-icon>
              Copy This Document
            </v-btn>
          </span>
        </template>
        <template #append-actions>
          <v-btn color="error" small v-if="$can('Delete', esv)" @click="deleteESV">
            <v-icon left>mdi-delete</v-icon>
            Delete this document
          </v-btn>
        </template>
      </tab-header>

      <v-row class="pb-4 pl-4" v-if="readonly">
        <v-col cols="3">
          <v-select v-if="readonly" hide-details="auto" v-model="selectedCultureId" max-width="200px"
            placeholder="Language" :items="supportedCultures" @input="selectCulture" outlined dense></v-select>
        </v-col>
      </v-row>
      <v-card-title class="grey lighten-3 py-2" dense> Summary </v-card-title>
      <v-card-text class="mt-3 black--text">

        <v-container fluid class="pa-0">
          <esv-summary v-if="readonly || !$can('Edit', esv, 'productGroupId')" :readonly="readonly" :esv="esv" :statusses="statusses" :serviceGrades="serviceGrades" :productGroups="productGroups" :productSubGroups="productSubGroups"></esv-summary>
          <v-container v-else>
            <v-row no-gutters>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pr-1' : 'pb-2'"
            >
              <v-row no-gutters>
                <v-col cols="12">
                  <!-- <editor :value="esv.subject" :readonly="readonly || !$can('Edit', esv, 'subject')" label="Subject" type="textarea"></editor> -->
                  <v-textarea
                    v-if="isFieldVisible(DocumentFields.Subject)"
                    :class="readonly ? '' : 'required'"
                    v-model="esv.subject"
                    hide-details="auto"
                    label="Subject"
                    outlined
                    dense
                    :readonly="readonly || !$can('Edit', esv, 'subject') || !isFieldEditable(DocumentFields.Subject)"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-row no-gutters>
                <v-col
                  cols="6"
                  sm="3"
                  :class="$vuetify.breakpoint.smAndUp ? 'pb-2' : 'pr-1 pb-2'"
                >
                  <!-- <v-select
                    v-model="esv.serviceRequestTypeId"
                    hide-details="auto"
                    :items="serviceRequestTypes"
                    label="Service Request Type"
                    outlined
                    dense
                    :readonly="readonly"
                  ></v-select> -->
                    <c-text-field v-model="serviceRequestType" label="Service Request Type"
                      :readonly="readonly || !$can('Edit', esv, 'serviceRequestType')"></c-text-field>
                    <!-- append-icon="mdi-menu-down" -->
                </v-col>
                <v-col
                  cols="6"
                  sm="5"
                  :class="$vuetify.breakpoint.smAndUp ? 'pb-2' : 'pl-1 pb-2'"
                >
                  <!-- <editor :value="esv.dossier" :readonly="readonly" label="Dossier"></editor> -->
                  <c-text-field
                    v-model="esv.dossier"
                    label="Dossier"
                    :readonly="readonly || !$can('Edit', esv, 'dossier')"
                  ></c-text-field>
                </v-col>
                <v-col
                  cols="6"
                  sm="2"
                  :class="$vuetify.breakpoint.smAndUp ? 'pb-2' : 'pr-1 pb-2'"
                >
                  <c-text-field
                    v-if="!$common.isRns(esv)"
                    v-model="esv.version"
                    label="Version"
                    :readonly="readonly || !$can('Edit', esv, 'version')"
                  ></c-text-field>
                </v-col>
                <v-col
                  cols="6"
                  sm="2"
                  :class="$vuetify.breakpoint.smAndUp ? 'pb-2' : 'pl-1 pb-2'"
                >
                  <c-text-field
                    v-model="esv.revision"
                    label="Revision"
                    :readonly="readonly || !$can('Edit', esv, 'revision')"
                  ></c-text-field>
                </v-col>
                <v-col cols="12" v-if="esv.revision" class="pb-2">
                  <date-picker
                    v-if="isFieldVisible(DocumentFields.OriginalIssueDate)"
                    hide-details="auto"
                    label="Original issue date"
                    v-model="esv.originalIssueDate"
                    @input="(value) => (esv.originalIssueDate = value)"
                    :readonly="true"
                  ></date-picker>
                </v-col>
                <v-col cols="12">
                  <date-picker
                    v-if="isFieldVisible(DocumentFields.IssueDate)"
                    :required="!readonly"
                    :rules="[$common.rules.required]"
                    hide-details="auto"
                    label="Issue date"
                    v-model="esv.issueDate"
                    @input="(value) => (esv.issueDate = value)"
                    :readonly="readonly || !$can('Edit', esv, 'issueDate')"
                  ></date-picker>
                </v-col>
              </v-row>
            </v-col>

              <!-- <v-col cols="6">
                        <v-textarea v-model="esv.serviceRequestNr" label="Service request Nr" rows="1" class="mx-2"></v-textarea>
                </v-col> -->
          </v-row>
          <v-row
            no-gutters
            :class="$vuetify.breakpoint.smAndUp ? 'mt-2' : 'mt-0'"
          >
            <v-col

              cols="12"
              sm="6"
              order="4"
              order-sm="1"
              :class="$vuetify.breakpoint.smAndUp ? 'pr-1 pb-2' : 'pb-2'"
            >
              <c-select
                v-if="isFieldVisible(DocumentFields.Status)"
                v-model="esv.statusId"
                label="Status"
                :items="statusses"
                :readonly="readonly || !$can('Edit', esv, 'status')"
              ></c-select>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              order="1"
              order-sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1 pb-2' : 'pb-2'"
            >
              <date-picker
                v-if="isFieldVisible(DocumentFields.ServiceLimitTime)"
                :dotted="!readonly"
                label="Service limit time"
                hide-details="auto"
                v-model="esv.serviceLimitTime"
                @input="(value) => (esv.serviceLimitTime = value)"
                :readonly="readonly || !$can('Edit', esv, 'serviceLimitTime')"
              ></date-picker>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              order="3"
              order-sm="3"
              :class="$vuetify.breakpoint.smAndUp ? 'pr-1 pb-2' : 'pb-2'"
            >
              <!-- <editor v-model="esv.serviceGradeId"
                hide-details="auto"
                label="Service Grade"
                outlined
                append-icon="mdi-menu-down"
                dense
                :items="serviceGrades" type="select"
                :readonly="readonly || !$can('Edit', esv, 'serviceGradeId')"></editor> -->
              <c-select
                v-model="esv.serviceGradeId"
                v-if="isFieldVisible(DocumentFields.ServiceGrade)"
                label="Service Grade"
                :items="serviceGrades"
                :class="{ required: !readonly }"
                :readonly="readonly || !$can('Edit', esv, 'serviceGradeId') || !isFieldEditable(DocumentFields.ServiceGrade)"
              ></c-select>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              order="2"
              order-sm="4"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1 pb-2' : 'pb-2'"
            >
              <c-text-field
                v-if="isFieldVisible(DocumentFields.ServicePeriod)"
                :class="readonly ? '' : 'dotted'"
                v-model="esv.servicePeriod"
                label="Service period in years"
                :rules="[$common.rules.decimal]"
                :readonly="readonly || !$can('Edit', esv, 'servicePeriod')"
              ></c-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mt-4 mb-4" no-gutters>
              <v-col cols="12">
                <v-select
                  class="required"
                  v-if="!readonly && $common.isRns(esv)"
                  v-model="esv.confidentiality"
                  label="Confidentiality"
                  :items="confidentialityOptions"
                  :rules="[$common.rules.required]"
                  outlined
                  dense
                  hide-details="auto"
                ></v-select>
                  <v-select
                    v-else
                    v-model="esv.confidentiality"
                    :items="internalUseOnlyOption"
                    label="Confidentiality"
                    outlined
                    dense
                    hide-details="auto"
                    disabled
                  ></v-select>
              </v-col>
            </v-row>
          <v-divider></v-divider>
          <v-row no-gutters class="pt-2">
            <v-col cols="6" class="pr-1 pb-2">
              <c-autocomplete
                v-if="isFieldVisible(DocumentFields.ProductGroup)"
                v-model="esv.productGroupId"
                :items="productGroups"
                label="Product group"
                :clearable="true"
                :readonly="readonly || !$can('Edit', esv, 'productGroupId')"
              ></c-autocomplete>
            </v-col>
            <v-col cols="6" class="pl-1 pb-2">
              <c-autocomplete
                v-if="isFieldVisible(DocumentFields.ProductSubgroup)"
                v-model="esv.productSubGroupId"
                :items="productSubGroups"
                label="Product subgroup"
                :clearable="true"
                :readonly="readonly || !$can('Edit', esv, 'productSubGroupId')"
              ></c-autocomplete>
            </v-col>
          </v-row>
          </v-container>
          
          <v-card outlined v-if="(!readonly && $can('Edit', esv, 'publicMessage')) && isFieldVisible(DocumentFields.PublicMessage) || isFieldVisible(DocumentFields.PublicMessage) && esv.publicMessage" class="mt-2">
            <v-card-title class="text-subtitle-1 text-break blue lighten-4 py-2">
              Public Message
            </v-card-title>
            <v-card-text class="pa-0" v-if="!readonly && $can('Edit', esv, 'publicMessage')">
              <v-textarea hide-details="auto" v-model="esv.publicMessage" auto-grow outlined dense class="black--text"
                placeholder="Briefly describe the problem and solution in a less technical way in order to make it understandable for end users and sales people."></v-textarea>
            </v-card-text>
            <v-card-text v-else class="black--text">
              {{ esv.publicMessage }}
            </v-card-text>
          </v-card>
          
          <v-card outlined v-if="(esv.version > 1 || esv.revision) && ((!readonly && $can('Edit', esv, 'updateReason')) && isFieldVisible(DocumentFields.ReasonForUpdate) || isFieldVisible(DocumentFields.ReasonForUpdate) && esv.updateReason)" class="mt-2">
            <v-card-title class="text-subtitle-1 text-break blue lighten-4 py-2">
              Reason for update
            </v-card-title>
            <v-card-text :class="!readonly && $can('Edit', esv, 'updateReason') ? 'pa-0' : ''">
              <ckeditor v-if="!readonly && $can('Edit', esv, 'updateReason')" 
                v-model="esv.updateReason"
                :config="$common.ckEditorConfig" 
                @ready="$common.setupCKEditor"></ckeditor>
              <div v-else v-html="getProcessedContent(esv.updateReason)" class="rich-text-content black--text"></div>
            </v-card-text>
          </v-card>

          <v-card outlined v-if="isFieldVisible(DocumentFields.OrganisationalComment) && $can('ReadOrganisationComment', esv) && (!readonly || esv.organisationComment)" class="mt-2">
            <v-card-title class="text-subtitle-1 text-break blue lighten-4 py-2">
              Organisational Comment
            </v-card-title>
            <v-card-text :class="!readonly && $can('EditOrganisationComment', esv) ? 'pa-0' : ''">
              <ckeditor v-if="!readonly && $can('EditOrganisationComment', esv)" 
                v-model="esv.organisationComment"
                :config="$common.ckEditorConfig" 
                @ready="$common.setupCKEditor"
                placeholder="Briefly describe the problem and solution in a less technical way in order to make it understandable for end users and sales people.">
              </ckeditor>
              <div v-else v-html="getProcessedContent(esv.organisationComment)" class="rich-text-content black--text"></div>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="ma-sm-3" outlined>
      <v-card-title class="grey lighten-3 py-2"> Detail </v-card-title>
      <v-card-text>
        <!-- 1. Applied model + manufactoring nrs. -->
        <v-card outlined class="mt-1" v-if="isFieldVisible(DocumentFields.AppliedModelMfgNrs)" >
          <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
            {{ sectionNumbers.appliedModel }}. Applied model + manufacturing nrs.
            <v-spacer></v-spacer>
            <v-badge
                v-if="$can('DownloadModelExcl', esv)"
                color="error"
                class="mr-5"
                overlap
                :content="appliedModelsXModelDatatable.numberOfModelExclusions"
                :value="appliedModelsXModelDatatable.numberOfModelExclusions"
            >
              <v-btn
                  color="success"
                  @click="downloadExclusionRanges"
                  :disabled="
          !appliedModelsXModelDatatable.numberOfModelExclusions
        "
                  :loading="downloadExclusionRangesLoading"
              >
                Download exclusions
              </v-btn>
            </v-badge>

            <v-btn
                @click="newAppliedModelsXModel"
                color="primary"
                class="ml-2"
                v-if="!readonly && $can('EditModelsInScope', esv)"
            >
              Update models in scope
            </v-btn>
          </v-card-title>
          <v-card-text>
            <template v-if="readonly && !hasAppliedModelContent">
              <span class="text-subtitle-2 grey--text mt-4 d-block">Not applicable</span>
            </template>
            <template v-else>
              <v-data-table
                  dense
                  :headers="filteredHeaders"
                  :items="appliedModelsXModelDatatable.items"
                  :options.sync="appliedModelsXModelDatatable.options"
                  :footer-props="{
                    'items-per-page-options': [15, 50, 100, -1],
                  }"
                  :items-per-page="50"
                  :server-items-length="appliedModelsXModelDatatable.totalItems"
                  show-expand
                  item-key="appliedModelsXModelId"
              >
                <template v-slot:header="{ props: { headers } }">
                  <data-table-search-header
                      :headers="headers"
                      :headerSelects="appliedModelsXModelDatatable.headerSelects"
                      @search="getAppliedModelsXModels"
                      ref="appliedModelsXModelDatatable"
                  >
                  </data-table-search-header>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <linked-parts :esvId="id" :item="item"></linked-parts>
                  </td>
                </template>
              </v-data-table>

              <v-card outlined v-if="isFieldVisible(DocumentFields.SpecificComplementaryCondition) && 
          (!readonly ? true : esv.specificComplementaryConditionChecked)">
                <v-card-title class="text-subtitle-2 text-break blue lighten-3 py-1">
                  <v-row dense no-gutters>
                    <v-col v-if="shouldShowCheckbox('specificComplementaryCondition', 'appliedModel')" cols="auto">
                      <v-checkbox
                          v-model="esv.specificComplementaryConditionChecked"
                          class="ma-0 pt-0"
                          hide-details
                          :disabled="isCheckboxDisabled('specificComplementaryCondition', 'appliedModel')"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      Specific Complementary Condition
                      <span v-if="!esv.specificComplementaryConditionChecked && itemHasContent('specificComplementaryCondition', 'appliedModel')"
                            class="hidden-content-warning ml-2">
                (has hidden content)
              </span>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text v-if="esv.specificComplementaryConditionChecked">
                  <v-textarea
                      hide-details="auto"
                      v-model="esv.specificComplementaryCondition"
                      dense
                      placeholder="If applicable, specify installation/operation/applications conditions or regions. If applicable, specify 'Excl. units reworked in DENV/factory stock (see appendix xxx for mfg nrs)' and specify how to recognized reworked units (eg. green dot)"
                      :readonly="readonly || !$can('Edit', esv, 'specificComplementaryCondition')"
                  ></v-textarea>
                </v-card-text>
              </v-card>

              <v-card outlined v-if="isFieldVisible(DocumentFields.TotalQuantityOfUnitsInScope) && 
          (!readonly ? true : esv.totalQuantityOfUnitsInScopeChecked)">
                <v-card-title class="text-subtitle-2 text-break blue lighten-3 py-1">
                  <v-row dense no-gutters>
                    <v-col v-if="shouldShowCheckbox('totalQuantityOfUnitsInScope', 'appliedModel')" cols="auto">
                      <v-checkbox
                          v-model="esv.totalQuantityOfUnitsInScopeChecked"
                          class="ma-0 pt-0"
                          hide-details
                          :disabled="isCheckboxDisabled('totalQuantityOfUnitsInScope', 'appliedModel')"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      Total Quantity of Units In Scope
                      <span v-if="!esv.totalQuantityOfUnitsInScopeChecked && itemHasContent('totalQuantityOfUnitsInScope', 'appliedModel')"
                            class="hidden-content-warning ml-2">
                (has hidden content)
              </span>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text v-if="esv.totalQuantityOfUnitsInScopeChecked">
                  <c-text-field
                      class="ma-0 pt-1 custom-total-quantity"
                      v-model="esv.totalQuantityOfUnitsInScope"                      
                      label="Total quantity of units"
                      :readonly="readonly || !$can('Edit', esv, 'totalQuantityOfUnitsInScope')"
                  ></c-text-field>    
                </v-card-text>
              </v-card>
            </template>
          </v-card-text>
        </v-card>
        <!-- 2. Detail of trouble -->
        <v-card outlined class="mt-1" v-if="$can('Read', esv, 'phenomenon') && isFieldVisible(DocumentFields.DetailOfTrouble)">
          <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
            {{ sectionNumbers.detailOfTrouble }}. Detail of trouble
            <v-spacer></v-spacer>
            <v-btn
              v-if="!readonly"
              icon
              class="d-none d-md-flex"
              @click="gridView.phenomena = !gridView.phenomena"
            >
              <v-icon v-if="gridView.phenomena">mdi-view-grid</v-icon>
              <v-icon v-else>mdi-view-stream</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-4">
            <template v-if="readonly && !hasDetailOfTroubleContent">
              <span class="text-subtitle-2 grey--text mt-4 d-block">Not applicable</span>
            </template>
            <v-row v-else>
              <v-col
                cols="12"
                :md="gridView.phenomena ? 6 : 12"
                v-for="(phenomenon, index) in esv.phenomena"
                :key="index"
                class="pa-1"
              >
                <v-card outlined v-if="shouldShowItem(phenomenon, 'phenomenon')">
                  <v-card-title class="text-subtitle-2 grey lighten-3 text-break py-2">
                    <v-row dense no-gutters>
                      <v-col v-if="shouldShowCheckbox(phenomenon, 'phenomenon')" cols="auto" class="d-flex align-center pa-0">
                        <v-checkbox
                          v-model="phenomenon.checked"
                          @change="toggleItemContent(phenomenon, $event)"
                          class="ma-0 pt-0"
                          hide-details
                          :disabled="isCheckboxDisabled(phenomenon, 'phenomenon') || !$can('Edit', esv, 'phenomenon')"
                        ></v-checkbox>
                      </v-col>
                      <v-col class="d-flex align-center pa-0">
                        {{ phenomenon.type }}
                        <span v-if="!phenomenon.checked && itemHasContent(phenomenon)" class="hidden-content-warning ml-2">
                          (has hidden content)
                        </span>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="3" md="1" v-if="phenomenon.checked">
                        <v-text-field
                          v-if="shouldShowRatio(phenomenon)"
                          :value="getRatio(phenomenon)"
                          @input="setRatio(phenomenon, $event)" 
                          hide-details="auto"
                          label="Ratio"
                          append-icon="mdi-percent text-body-1"
                          class="ma-0 white text-body-1"
                          outlined
                          dense
                          :rules="[$common.rules.decimal]"
                          :readonly="readonly || !isFieldEditable(getFieldName(phenomenon, 'phenomenon')) || !$can('Edit', esv, 'phenomenon')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text v-if="phenomenon.checked" :class="readonly ? 'pb-0' : 'pa-0'">
                    <ckeditor
                      class="ma-0"
                      v-if="!readonly && $can('Edit', esv, 'phenomenon') && isFieldEditable(getFieldName(phenomenon, 'phenomenon'))"
                      v-model="phenomenon.description"
                      :config="$common.ckEditorConfig"
                      @ready="$common.setupCKEditor"
                    ></ckeditor>
                    <div
                      v-else-if="phenomenon.description"
                      v-html="getProcessedContent(phenomenon.description)"
                      class="ma-0 rich-text-content black--text"
                    ></div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 3. Countermeasure -->
        <v-card outlined class="mt-1" v-if="isFieldVisible(DocumentFields.Countermeasure)">
          <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
            {{ sectionNumbers.countermeasure }}. Countermeasure
            <v-spacer></v-spacer>
            <v-btn
              v-if="!readonly"
              icon
              class="d-none d-md-flex"
              @click="gridView.countermeasures = !gridView.countermeasures"
            >
              <v-icon v-if="gridView.countermeasures">mdi-view-grid</v-icon>
              <v-icon v-else>mdi-view-stream</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-4">
            <template v-if="readonly && !hasCountermeasureContent">
              <span class="text-subtitle-2 grey--text mt-4 d-block">Not applicable</span>
            </template>
            <v-row v-else>
              <v-col
                cols="12"
                :md="gridView.countermeasures ? 6 : 12"
                v-for="(countermeasure, index) in esv.countermeasures"
                :key="index"
                class="pa-1"
              >
                <v-card outlined v-if="shouldShowItem(countermeasure, 'countermeasure')">
                  <v-card-title class="text-subtitle-2 grey lighten-3 text-break py-2">
                    <v-row dense no-gutters>
                      <v-col v-if="shouldShowCheckbox(countermeasure, 'countermeasure')" cols="auto">
                        <v-checkbox
                          v-model="countermeasure.checked"
                          @change="toggleItemContent(countermeasure, $event)"
                          class="ma-0 pt-0"
                          hide-details
                          :disabled="isCheckboxDisabled(countermeasure, 'countermeasure') || !$can('Edit', esv, 'countermeasure')"
                        ></v-checkbox>
                      </v-col>
                      <v-col>
                        {{ countermeasure.type }}
                        <span v-if="!countermeasure.checked && itemHasContent(countermeasure)" class="hidden-content-warning ml-2">
                          (has hidden content)
                        </span>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="3">
                        <!-- <v-text-field v-if="countermeasure.ratioNumber" v-model="countermeasure.ratioNumber" label="Ratio" append-icon="mdi-percent" outlined dense></v-text-field> -->
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text v-if="countermeasure.checked" :class="readonly ? 'pb-0' : 'pa-0'">
                    <ckeditor
                      class="ma-0"
                      v-if="!readonly && $can('Edit', esv, 'countermeasure') && isFieldEditable(getFieldName(countermeasure, 'countermeasure'))"
                      v-model="countermeasure.description"
                      :config="$common.ckEditorConfig"
                      @ready="$common.setupCKEditor"
                    ></ckeditor>
                    <div
                      v-else-if="countermeasure.description"
                      v-html="getProcessedContent(countermeasure.description)"
                      class="ma-0 rich-text-content black--text"
                    ></div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 4. Spare parts / Service parts (to be ordered via spare parts route) -->
        <v-card v-if="isFieldVisible(DocumentFields.SpareParts)" outlined class="mt-1">
          <v-card-title class="text-subtitle-1 grey lighten-3 text-break">
            {{ sectionNumbers.spareParts }}. Spare parts / Service parts (to be ordered via spare parts route)
            <v-spacer></v-spacer>
            <v-btn
                @click="newSparePart"
                color="primary"
                v-if="!readonly && $can('UpdateParts', esv)"
                min-width="300"
            >
              Update parts in scope
            </v-btn>
          </v-card-title>
          <v-card-text>
            <template v-if="readonly && (!sparePartsDatatable.items || sparePartsDatatable.items.length === 0)">
              <span class="text-subtitle-2 grey--text mt-4 d-block">Not applicable</span>
            </template>
            <v-data-table
                v-else
                dense
                :headers="sparePartsDatatable.headers.filter(h => !h.caslField || $can('Read', esv, h.caslField))"
                :items="sparePartsDatatable.items"
                :footer-props="{
        'items-per-page-options': [15, 50, 100, -1],
      }"
                :items-per-page="50"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
        <!-- 5. Service cost -->
        <v-card v-if="isFieldVisible(DocumentFields.ServiceCost)" outlined class="mt-1" v-show="$can('Read', esv, 'serviceCosts')">
          <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
            {{ sectionNumbers.serviceCost }}. Service cost
            <v-spacer></v-spacer>
            <v-btn
                @click="newAppliedModel"
                v-if="!readonly && $can('UpdateServiceCosts', esv)"
                color="primary"
                min-width="300"
            >
              Update service costs
            </v-btn>
            <v-btn
                v-else
                @click="detailsServiceCosts"
                color="primary"
                min-width="300"
            >
              Details service costs
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-4">
            <template v-if="readonly && !hasServiceCostContent">
              <span class="text-subtitle-2 grey--text mt-4 d-block">Not applicable</span>
            </template>
            <template v-else>
              <v-checkbox
                  hide-details="auto"
                  class="ma-0 mb-1 pa-0"
                  v-model="esv.labourAndExpenses"
                  label="Labour And Expenses (/unit)"
                  :disabled="readonly || !$can('Edit', esv, 'labourAndExpenses')"
              ></v-checkbox>
              <v-data-table
                  dense
                  :headers="appliedModelsDatatable.headers"
                  :items="appliedModelsDatatable.items"
                  :footer-props="{
          'items-per-page-options': [15, 50, 100, -1],
        }"
                  :items-per-page="50"
              >
              </v-data-table>
              <v-checkbox
                  hide-details="auto"
                  class="ma-0 pa-0"
                  v-model="esv.servicePartsCost"
                  label="Service Parts Cost"
                  :disabled="readonly || !$can('Edit', esv, 'servicePartsCost')"
              ></v-checkbox>
            </template>
          </v-card-text>
        </v-card>
        <!-- 6. Cost claim procedure -->
        <v-card outlined class="mt-1" v-if="isFieldVisible(DocumentFields.CostClaimProcedure) && $can('Read', esv, 'costClaimProcedure')">
          <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
            {{ sectionNumbers.costClaimProcedure }}. Cost claim procedure
            <v-spacer></v-spacer>
            <v-btn color="warning" v-if="!readonly && $can('Edit', esv, 'costClaimProcedure')" @click="setDefaultCCP"
              min-width="300">
              Default template
            </v-btn>
          </v-card-title>
          <v-card-text :class="readonly ? 'mt-4 pb-4': 'pa-0'">
            <!-- <v-textarea v-model="esv.costClaimProcedure" label="Cost claim procedure" class="mx-2"></v-textarea> -->
            <ckeditor
              v-if="!readonly && $can('Edit', esv, 'costClaimProcedure')"
              v-model="esv.costClaimProcedure"
              :config="$common.ckEditorConfig"
              @ready="$common.setupCKEditor"
            ></ckeditor>
            <div v-else-if="esv.costClaimProcedure" v-html="getProcessedContent(esv.costClaimProcedure)" class="rich-text-content black--text"></div>
            <span v-else class="text-subtitle-2 grey--text mt-4 d-block">Not applicable</span>
          </v-card-text>
        </v-card>
        <!-- 7. Remark -->
        <v-card outlined class="mt-1" v-if="isFieldVisible(DocumentFields.Remark) && $can('Read', esv, 'remark')">
          <v-card-title class="text-subtitle-1 grey lighten-3 py-2">
            {{ sectionNumbers.remark }}. Remark
          </v-card-title>
          <v-card-text>
            <ckeditor
              v-if="!readonly && $can('Edit', esv, 'remark')"
              v-model="esv.remark"
              :config="$common.ckEditorConfig"
              @ready="$common.setupCKEditor"
            ></ckeditor>
            <div v-else-if="esv.remark" v-html="getProcessedContent(esv.remark)" class="rich-text-content"></div>
            <span v-else class="text-subtitle-2 grey--text mt-4 d-block">Not applicable</span>
          </v-card-text>
        </v-card>
        
        <!-- 8. SV Numbers -->
        <v-card outlined class="mt-1" v-if="isFieldVisible(DocumentFields.SVNumbers) && $can('Read', esv, 'svNumbers')">
          <v-card-title class="text-subtitle-1 grey lighten-3 py-2">
            {{ sectionNumbers.svNumbers }}. SV Numbers
          </v-card-title>
          <v-card-text>
            <v-text-field v-if="!readonly && $can('Edit', esv, 'svReference')" v-model="esv.svReference" label="Based On SV" outlined dense hide-details="auto" clearable></v-text-field>
            <template v-if="readonly && !esv.svReference && (!claimReferences || claimReferences.length === 0)">
              <span class="text-subtitle-2 grey--text mt-4 d-block">Not applicable</span>
            </template>
            <v-data-table
                v-else
                dense
                :headers="svNumberHeaders"
                :items="claimReferences"
                :footer-props="{
        'items-per-page-options': [15, 50, 100, -1],
      }"
                :items-per-page="50"
            ></v-data-table>
          </v-card-text>
        </v-card>

        <!-- 9. Appendix & work instructions -->
        <attachments v-if=" isFieldVisible(DocumentFields.AppendixAndWorkInstructions) && $can('Read', esv, 'attachments')"
          :esvId="id"
          :readonly="readonly || !$can('UpdateAttachments', esv)" 
          :sectionNumber="sectionNumbers.appendix"
        ></attachments>
      </v-card-text>
    </v-card>
    <v-row no-gutters>
      <v-col cols="6" sm="3" v-if="isFieldVisible(DocumentFields.IssuedBy)">
        <ApproverCard :esv="esv" :approver="esv.executedBy" title="Issued by" :readonly="readonly" style="height: 100%">
          <template
            #ApproverSelect
            v-if="!readonly && $can('Edit', esv, 'executedBy')"
          >
            <v-autocomplete
              hide-details="auto"
              dense
              v-model="esv.executedById"
              :items="availableApprovers"
              label="Issued by"
              outlined
              @input="handleApproverInput('executedById', $event)"
              :disabled="!canEditApprover(esv.issuedBy, 'issuedBy')"
            ></v-autocomplete>
          </template>
        </ApproverCard>
      </v-col>
      <v-col cols="6" sm="3" v-if="isFieldVisible(DocumentFields.CheckedBy)">
        <ApproverCard :esv="esv" :approver="esv.checkedBy" title="Checked by" :readonly="readonly" style="height: 100%">
          <template
            #ApproverSelect
            v-if="!readonly && $can('Edit', esv, 'checkedBy')"
          >
            <v-autocomplete
              hide-details="auto"
              dense
              v-model="esv.checkedById"
              :items="availableApprovers"
              label="Checked by"
              outlined
              @input="handleApproverInput('checkedById', $event)"
              :disabled="!canEditApprover(esv.checkedBy, 'checkedBy')"
            ></v-autocomplete>
          </template>
        </ApproverCard>
      </v-col>
      <v-col cols="6" sm="3" v-if="isFieldVisible(DocumentFields.ApprovedBy1)">
        <ApproverCard :esv="esv" :approver="esv.approvedBy1" title="Approved by" :readonly="readonly" style="height: 100%">
          <template
            #ApproverSelect
            v-if="!readonly && $can('Edit', esv, 'approvedBy1')"
          >
            <v-autocomplete
              hide-details="auto"
              dense
              v-model="esv.approvedBy1Id"
              :items="availableApprovers"
              label="Approved by"
              outlined
              @input="handleApproverInput('approvedBy1Id', $event)"
              :disabled="!canEditApprover(esv.approvedBy1, 'approvedBy1')"
            ></v-autocomplete>
          </template>
        </ApproverCard>
      </v-col>
      <v-col cols="6" sm="3" v-if="isFieldVisible(DocumentFields.ApprovedBy2)">
        <ApproverCard :esv="esv" :approver="esv.approvedBy2" title="Approved by" :readonly="readonly" style="height: 100%">
          <template
            #ApproverSelect
            v-if="!readonly && $can('Edit', esv, 'approvedBy2')"
          >
            <v-autocomplete
              hide-details="auto"
              dense
              v-model="esv.approvedBy2Id"
              :items="availableApprovers"
              label="Approved by"
              outlined
              @input="handleApproverInput('approvedBy2Id', $event)"
              :rules="approvedBy2Rules"
              :disabled="!canEditApprover(esv.approvedBy2, 'approvedBy2')"
            ></v-autocomplete>
          </template>
        </ApproverCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col></v-col>
      <v-col></v-col>
    </v-row>

    <AppliedModelsXModelEditDialog
      :dialog="appliedModelsXModelDatatable.editDialog"
      :esvId="id"
      :esv="esv"
      @saveExclusions="putEsvUpdate"
      @close="handleAppliedModelsXModelsDialogClose"
      @save="handleAppliedModelsXModelsDialogClose"
      @search="getAppliedModelsXModels"
      :readonly="readonly"
    ></AppliedModelsXModelEditDialog>
    <model-group-dialog
      :esvId="id"
      :esv="esv"
      :dialog="appliedModelsDatatable.editDialog"
      @close="(appliedModelsDatatable.editDialog) = false"
      @updated="appliedModelUpdated"
      @deleted="appliedModelDeleted"
      ref="appliedModelEdit"
      :readonly="readonly || !$can('UpdateServiceCosts', esv)"
    ></model-group-dialog>

    <!-- <v-dialog v-model="sparePartsDatatable.editDialog">
        <SparePartsEdit :model="sparePartsDatatable.editModel" :title="sparePartsDatatable.editDialogTitle" @close="sparePartsDatatable.editDialog = false" @updated="appliedModelXPartsUpdated" ref="appliedModelxPartEdit" />
    </v-dialog> -->
    <EditDialog :dialog="sparePartsDatatable.editDialog" :valid="true" @close="(sparePartsDatatable.editDialog) = false"
      @save="(sparePartsDatatable.editDialog) = false">
      <template #title>
        {{ sparePartsDatatable.editDialogTitle }}
      </template>
      <template #body>
        <SparePartsEdit :esvId="id" ref="appliedModelxPartEdit" @updated="getParts" />
      </template>
    </EditDialog>

    <div style="height: 150px;"></div>

    <tab-footer v-if="!readonly" :esv="esv" :loading="esvLoading" @save="putEsvUpdate"
      @start-approval="putEsvUpdate(true)" @cancel="$emit('edit')">
    </tab-footer>
    <approve-reject :esvId="this.id"
      v-if="readonly && ($can('ApproveAny', esv) || ($can('Approve', esv) && isApprover))"></approve-reject>
    <publish-footer v-if="readonly" :esv="esv"></publish-footer>
  </div>
</template>

<script>
// @ is an alias to /src

import DatePicker from "../common/DatePicker.vue";
import unsavedChangesWarningMixin from '@/mixins/unsavedChangesWarningMixin';

import exportTypes from "@/enums/ExportType.js";
import TabHeader from "./TabHeader.vue";
// import TabFooter from "./TabFooter.vue";
// import Editor from '@/components/common/Editor.vue'

import lodash from 'lodash';
import {FieldStatus} from "@/enums/FieldStatus";
import {DocumentFields} from "@/enums/DocumentFields";
import { convertImagesToBlobs } from '@/services/Common';

const fieldConfigs = {
  // Each section with its complete paths
  'phenomenon': {
    type: 'array',
    items: {
      'Phenomena': DocumentFields.Phenomena,
      'Estimated Failure Ratio': DocumentFields.EstimatedRatio,
      'Cause': DocumentFields.Cause
    }
  },
  'countermeasure': {
    type: 'array',
    items: {
      'Content': DocumentFields.CountermeasureContent,
      'Field installed units': DocumentFields.FieldInstalledUnits,
      'Field stock units': DocumentFields.FieldStockUnits,
      'DENV stock units': DocumentFields.DENVStockUnits,
      'Mass production units': DocumentFields.MassProductionUnits,
      'Field spare parts stock': DocumentFields.FieldSparePartsStock,
      'DENV spare parts stock': DocumentFields.DENVSparePartsStock
    }
  },
  'appliedModel': {
    type: 'fields',
    items: {
      'specificComplementaryCondition': {
        path: DocumentFields.SpecificComplementaryCondition,
        defaultEmpty: ''
      },
      'totalQuantityOfUnitsInScope': {
        path: DocumentFields.TotalQuantityOfUnitsInScope,
        defaultEmpty: ''
      }
    }
  }
};


export default {
  name: "Details",
  mixins: [unsavedChangesWarningMixin], // Added mixin
  components: {
    //   DatePicker,
    //   AppliedModelEditDialog,
    AppliedModelsXModelEditDialog: () =>
      import("@/components/AppliedModelsXModel/EditDialog"),
    SparePartsEdit: () => import("@/components/SparePart/Edit"),
    ApproverCard: () => import("@/components/ESV/ApprovalCard"),
    DatePicker,
    EditDialog: () => import("@/components/common/EditDialog"),
    ModelGroupDialog: () =>
      import("@/components/AppliedModel/ModelGroupDialog"),
    Attachments: () => import("@/components/ESV/Attachments.vue"),
    TabHeader,
    TabFooter: () => import("@/components/ESV/TabFooter.vue"),
    ApproveReject: () => import("@/components/ESV/ApproveReject.vue"),
    PublishFooter: () => import("@/components/ESV/PublishFooter.vue"),
    LinkedParts: () => import('@/components/AppliedModel/LinkedParts.vue'),
    DataTableSearchHeader: () => import("@/components/common/DataTableSearchHeader.vue"),
    // Editor,
    EsvSummary: () => import('@/components/ESV/Summary.vue')
  },
  props: {
    id: Number,
    readonly: Boolean,
    lockLoading: Boolean,
    saveCounter: Number,
    tabChangeSaveCounter: Number,
    reloadCounter: Number,
    isConfirmingTabChange: Boolean
  },
  created() {
    this.init();

    this.$watch(() => this.appliedModelsXModelDatatable.search["productGroup"], this.onProductGroupSelect);
  },
    data() {
    return {
      ckeditorKey: 0,
      isInitializing: false,
      apiCheckboxes: {
        suppressToastOnce: false,
        productNumberChecked: true,
        poscodeChecked: true,
        materialChecked: true,
        serialFromChecked: true,
        serialToChecked: true,
        specificComplementaryConditionChecked: false,
        totalQuantityOfUnitsInScopeChecked: false
      },
      editModeLoading: false,
      confidentialityOptions: [
        { value: 1, text: 'For internal use only' },
        { value: 2, text: 'Public' },        
        ],
      internalUseOnlyOption: [
        { value: 1, text: 'For internal use only' },
      ],
      selectedCultureId: parseInt(this.$store.state.user.selectedCultureId),
      esv: {
        phenomena: [],
        countermeasures: [], 
        confidentiality: 1,
        appliedModelsXModelsChecked: [],
      },
      approvalSheet: true,
      svNumberHeaders: [
        { text: "SV Number", value: "svNumber" },
        { text: "Claim Reference", value: "claimReference" },
      ],
      productGroups: [],
      //   productSubGroups: [],
      statusses: [],
      serviceGrades: [],
      supportedCultures: [],
      sparePartsDatatable: {
        editModel: {},
        editDialog: false,
        editDialogTitle: "Add item",
        items: [],
        headers: [
          { text: "Number", value: "number" },
          { text: "Description", value: "description" },
          { text: "Quantity", value: "quantity" },
          { text: "Cost", value: "cost", caslField: 'cost' },
          { text: "Model Group", value: "productModelGroup" },
          { text: "Remark", value: "productRemark" },
          // {text: "Actions", value: "actions"}
        ],
        loading: false,
        totalItems: 50
      },
      appliedModelsDatatable: {
        editDialog: false,
        editDialogTitle: "Add item",
        items: [],
        loading: false,
        headers: [
          { text: "Countermeasure or condition", value: "countermeasure" },
          { text: "Labour and expenses (/unit)", value: "labourCost" },
          { text: "Claim Reference", value: "claimReference" },
        ],
      },
      appliedModelsXModelDatatable: {
        totalItems: null,
        options: { itemsPerPage: 50 },
        editDialog: false,
        editDialogTitle: "Add",
        loading: false,
        items: [],
        headers: [
          { text: "Product Number", value: "productNumber", type: "text", class: "text-subtitle-1 font-weight-bold" },
          { text: "POS Code", value: "poscode", type: "text", class: "text-subtitle-1 font-weight-bold" },
          { text: "Material", value: "material", type: "text", class: "text-subtitle-1 font-weight-bold" },
          { text: "Product Group", value: "productGroup", type: "select", class: "text-subtitle-1 font-weight-bold" },
          { text: "Product Subgroup", value: "productSubGroup", type: "select", class: "text-subtitle-1 font-weight-bold" },
          { text: "Serial From", value: "serialFrom", type: "text", class: "text-subtitle-1 font-weight-bold" },
          { text: "Serial To", value: "serialTo", type: "text", class: "text-subtitle-1 font-weight-bold" },
        ],
        headerSelects: { 'productGroup': [] },
        search: []
      },

      esvLoading: false,
      serviceRequestTypes: [],
      serviceLimitMenu: false,
      issueDateMenu: false,
      gridView: {
        phenomena: false,
        countermeasures: false,
      },
      availableApprovers: [],
      downloadModelsAndPartsLoading: false,
      downloadDetailsLoading: false,
      downloadExclusionRangesLoading: false,
      claimReferences: [],
      processedContent: new Map(), // Cache for processed HTML content
      updateTimer: null, // Add timer for debounced updates
      lastSaveSource: null, // Track source of last save
    };
    //   readonly: true,
  },
  methods: {
    async init() {
      if (this.isInitializing) {
        return;
      }
      this.isInitializing = true;
      try {
        await this.getEsvDetails(); // Ensure this is async and updates this.esv
        
        // Synchronous parts of init can remain here
        this.getProductGroups();
        this.getStatusses();
        this.getAppliedModels();
        this.getServiceRequestTypes();
        this.getServiceGrades();
        this.getAppliedModelsXModels();
        this.getParts();
        this.getAvailableUsersForDropdown();
        this.getClaimReferences();
        this.getSupportedCultures();
      } catch (error) {
        console.error("❌ INIT: Error during initialization:", error);
      } finally {
        this.isInitializing = false;
      }
    },

    async prepareForEditMode() {
      if (this.readonly && this.selectedCultureId != 1) {
        this.selectedCultureId = 1;
        await this.selectCulture(); 
        if(this.isInitializing){
            await new Promise(resolve => {
                const unwatch = this.$watch('isInitializing', (newVal) => {
                    if(!newVal) {
                        unwatch();
                        resolve();
                    }
                });
            });
        }
      }
      
      this.editModeLoading = true;
      
      try {
        await new Promise(resolve => {
          let initStartedDueToReload = false;
          const unwatchInit = this.$watch('isInitializing', (newValue, oldValue) => {
            if (this.reloadCounter > initialReloadCounterForEdit && oldValue === false && newValue === true) {
              initStartedDueToReload = true;
            }
            if (initStartedDueToReload && oldValue === true && newValue === false) {
              unwatchInit();
              this.$nextTick(resolve); 
            }
          });

          const initialReloadCounterForEdit = this.reloadCounter;
          this.$emit('reload-requested'); 
        });
        
        await this.processAllContentForEdit();
        
        await this.$nextTick();
        
        this.ckeditorKey++;
      } catch (error) {
        console.error('❌ EDIT FLOW: Error entering edit mode:', error);
        throw error;
      } finally {
        this.editModeLoading = false;
      }
    },

    async edit() {
      try {
        await this.prepareForEditMode();
      } catch (error) {
        // Preserve the previous fallback behavior: still enter edit mode if preparation fails.
      }

      this.$emit("edit");
    },

    async processAllContentForEdit() {
      const updates = [];
      
      const richTextFields = [
        { key: 'updateReason', value: this.esv.updateReason },
        { key: 'organisationComment', value: this.esv.organisationComment },
        { key: 'costClaimProcedure', value: this.esv.costClaimProcedure },
        { key: 'remark', value: this.esv.remark }
      ];
      
      for (const field of richTextFields) {
        if (field.value) {
          const processedContent = await this.processHtmlContent(field.value);
          if (processedContent !== field.value) {
            updates.push(() => {
              this.$set(this.esv, field.key, processedContent);
            });
          }
        }
      }
      
      if (this.esv.phenomena) {
        for (let i = 0; i < this.esv.phenomena.length; i++) {
          const item = this.esv.phenomena[i];
          if (item.description) {
            const processedContent = await this.processHtmlContent(item.description);
            if (processedContent !== item.description) {
              const index = i; 
              updates.push(() => {
                this.$set(this.esv.phenomena[index], 'description', processedContent);
              });
            }
          }
        }
      }
      
      if (this.esv.countermeasures) {
        for (let i = 0; i < this.esv.countermeasures.length; i++) {
          const item = this.esv.countermeasures[i];
          if (item.description) {
            const processedContent = await this.processHtmlContent(item.description);
            if (processedContent !== item.description) {
              const index = i; 
              updates.push(() => {
                this.$set(this.esv.countermeasures[index], 'description', processedContent);
              });
            }
          }
        }
      }
      
      // Apply all updates at once
      updates.forEach((update) => {
        update();
      });
      
      await this.$nextTick();
      return updates.length > 0;
    },

    getFieldName(item, sectionType) {
      const config = fieldConfigs[sectionType];
      if (!config) return null;

      if (config.type === 'array') {
        return config.items[item.type] || null;
      }
      
      if (config.type === 'fields') {
        return config.items[item]?.path || null;
      }

      return null;
    },

    shouldShowCheckbox(item, sectionType) {
      const fieldName = this.getFieldName(item, sectionType);
      if (!fieldName) return false;
      const status = this.getFieldStatus(fieldName);
      return status !== FieldStatus.Keep && status !== FieldStatus.Disable;
    },

    isCheckboxDisabled(item, sectionType) {
      const fieldName = this.getFieldName(item, sectionType);
      if (!fieldName) return true;
      const status = this.getFieldStatus(fieldName);
      return status === FieldStatus.Disable || this.readonly;
    },

    itemHasContent(item) {
      // For phenomena/countermeasures (arrays)
      if (item && item.type) {
        return !!item.description || !!item.ratioNumber;
      }

      // For regular fields (e.g. specificComplementaryCondition)
      return !!this.esv[item] && this.esv[item] !== 0;
    },

    shouldShowItem(item, sectionType) {
      const fieldName = this.getFieldName(item, sectionType);
      if (!fieldName || !this.isFieldVisible(fieldName)) return false;

      const config = fieldConfigs[sectionType];
      const isChecked = config.type === 'array' ? item.checked : this.esv[`${item}Checked`];

      if (this.readonly) return isChecked;

      return config.type === 'array' ||
          (config.type === 'fields' && (isChecked || this.itemHasContent(item, sectionType)));
    },

    toggleItemContent(item, checked) {
      this.$set(item, 'checked', checked);
    },

    getRatio(phenomenon) {
      return phenomenon.ratioNumber || 0;
    },

    setRatio(phenomenon, value) {
      this.$set(phenomenon, 'ratioNumber', value === '' || value == null ? 0 : value);
    },

    shouldShowRatio(phenomenon) {
      const fieldVisible = this.isFieldVisible(DocumentFields.EstimatedRatio);
      if (this.readonly) {
        return fieldVisible && phenomenon.type === 'Estimated Failure Ratio' && !!phenomenon.ratioNumber;
      }
      return fieldVisible && phenomenon.type === 'Estimated Failure Ratio';
    },

    getFieldStatus(fieldName) {
      return this.$common.getFieldStatus(this.$store, this.esv, fieldName);
    },
    isShowEnabled(fieldName) {
      const status = this.getFieldStatus(fieldName);
      return FieldStatus.isEnabled(status);
    },
    isFieldVisible(fieldName) {
      return this.$common.isFieldVisible(this.$store, this.esv, fieldName);
    },
    isFieldEditable(fieldName) {
      return this.$common.isFieldEditable(this.$store, this.esv, fieldName);
    },
    
    async getEsvDetails() {
      const resp = await this.$api.getEsvDetails(this.id); 
      this.esv = resp.data;

      Object.entries(fieldConfigs).forEach(([sectionType, config]) => {
        if (config.type === 'array') {
          const items = config === fieldConfigs.phenomenon ? 
            this.esv.phenomena : this.esv.countermeasures;
          
          items?.forEach(item => {
            const fieldName = this.getFieldName(item, sectionType);
            const status = this.getFieldStatus(fieldName);
            this.$set(item, 'checked', FieldStatus.isEnabled(status));
          });
        } else if (config.type === 'fields') {
          Object.keys(config.items).forEach(fieldKey => {
            const fieldName = this.getFieldName(fieldKey, sectionType);
            const status = this.getFieldStatus(fieldName);
            this.$set(this.esv, `${fieldKey}Checked`, FieldStatus.isEnabled(status));
          });
        }
      });

      this.esv.phenomena = this.esv.phenomena?.sort(this.sortByKey) || [];
      this.esv.countermeasures = this.esv.countermeasures?.sort(this.sortByKey) || [];
    },

    getProductGroups() {
      //   this.$api.getProductGroups()
      //     .then(resp => this.productGroups = resp.data)
      this.$api
        .getProductGroupProductSubGroups(this.id)
        .then((resp) => {
          this.productGroups = resp.data;
          this.appliedModelsXModelDatatable.headerSelects["productGroup"] = resp.data;
        });
    },
    getSupportedCultures() {
      this.$api
        .getCultures()
        .then((resp) => (this.supportedCultures = resp.data));
    },
    //   getProductSubGroups(){
    //       this.$api.getProductSubGroups()
    //         .then(resp => this.productSubGroups = resp.data)
    //   },
    getStatusses() {
      this.$api.getStatusses().then((resp) => (this.statusses = resp.data));
    },
    getServiceGrades() {
      this.$api
        .getServiceGrades()
        .then((resp) => (this.serviceGrades = resp.data));
    },
    handleAppliedModelsXModelsDialogClose() {
      this.appliedModelsXModelDatatable.editDialog = false;
      this.getAppliedModelsXModels();
    },
    getAppliedModelsXModels(tableSearch) {
      if (!tableSearch) {
        tableSearch = this.$refs.appliedModelsXModelDatatable ? this.$refs.appliedModelsXModelDatatable.search : [];
      }
      this.appliedModelsXModelDatatable.search = tableSearch;

      var options = Object.assign({}, this.appliedModelsXModelDatatable.options);
      this.appliedModelsXModelDatatable.loading = true;
      options.id = this.id;
      this.$api.getAppliedModelsXModelsOverview(options, tableSearch)
          .then((resp) => {
            this.appliedModelsXModelDatatable.loading = false;
            this.appliedModelsXModelDatatable.items = resp.data.items;
            this.appliedModelsXModelDatatable.numberOfModelExclusions = resp.data.numberOfModelExclusions;
            this.appliedModelsXModelDatatable.totalItems = resp.data.totalItems;
            if (resp.data.fieldSettingsViewModel) {
              this.apiCheckboxes = {
                ...this.apiCheckboxes,
                ...resp.data.fieldSettingsViewModel,
              };
            }
          });
      this.getProductGroups();
    },
    getAppliedModels() {
      this.appliedModelsDatatable.loading = true;
      this.$api.getServiceCosts(this.id)
        .then((resp) => {
          this.appliedModelsDatatable.items = resp.data.items;
        })
        .finally(() => this.appliedModelsDatatable.loading = false);
    },
    getParts() {
      this.$api
        .getParts(this.id)
        .then((resp) => {
          var uniqueParts = [];
          resp.data.items.forEach(part => {
            if (uniqueParts.findIndex(up =>
              up.number === part.number && up.quantity === part.quantity
              && (up.productRemark === part.productRemark || (!up.productRemark && !part.productRemark))
              && (up.productModelGroup === part.productModelGroup || (!up.productModelGroup && !part.productModelGroup)))
              < 0) {
              uniqueParts.push(part);
            }
          })
          this.sparePartsDatatable.items = uniqueParts;
          // this.sparePartsDatatable.items =  resp.data.items;
        });
    },
    getServiceRequestTypes() {
      this.$api
        .getServiceRequestTypes()
        .then((resp) => (this.serviceRequestTypes = resp.data));
    },
    getAvailableUsersForDropdown() {
      this.$api
        .getAvailableUsersForDropdown()
        .then((resp) => (this.availableApprovers = resp.data));
    },
    getClaimReferences() {
      this.$api
        .getSvNumbersForEsv(this.id)
        .then((resp) => (this.claimReferences = resp.data));
    },

    detailsServiceCosts() {
      this.appliedModelsDatatable.editDialog = true;
    },

    //EDIT
    editAppliedModelsXModels(appliedModel) {
      this.$api
        .getAppliedModelsXModel(appliedModel.appliedModelsXModelId)
        .then((resp) => {
          this.appliedModelsXModelDatatable.editModel = resp.data;
          this.appliedModelsXModelDatatable.editDialog = true;
          this.appliedModelsXModelDatatable.editDialogTitle = "Edit model";
        });
    },

    //NEW
    newAppliedModelsXModel() {
      this.appliedModelsXModelDatatable.editModel = {};
      this.appliedModelsXModelDatatable.editDialog = true;
      this.appliedModelsXModelDatatable.editDialogTitle = "Add model";
      this.appliedModelsXModelDatatable.esv = this.esv;
    },
    newAppliedModel() {
      this.$confirm('<p><strong>Please make sure you have saved your changes</strong></p><p>This is required if you have updated models or parts</p><p>Continue?</p>')
        .then(resp => {
          if (resp) {
            this.appliedModelsDatatable.editDialog = true;
          }
        })
    },
    newSparePart() {
      this.sparePartsDatatable.editModel = {};
      this.sparePartsDatatable.editDialog = true;
      this.sparePartsDatatable.editDialogTitle = "Add sparepart";
    },

    //SAVE
    saveSparePart() {
      this.$api.putSparePartUpdate(this.model).then(() => {
        this.$toast.success("Changes have been saved");
        this.appliedModelXPartsUpdated();
      });
    },

    //DELETE
    deleteESV() {
      this.$confirm('Are you sure you want to delete this document?')
        .then(res => {
          if (res) {
            this.$api.deleteESV(this.esv.id).then(() => {
              this.$toast.success("Document has been deleted");
              this.$router.push({ name: "Home" });
            });
          }
        })
    },

    putEsvUpdate(startApproval) {
      if (startApproval && this.hasDataToDelete) {
        const warningMessage = "Warning: Some unchecked items contain values that will be permanently deleted.";

        this.$confirm(warningMessage).then(confirmed => {
          if (confirmed) {
            this.performUpdateInternal(startApproval);
          }
        });
      } else {
        this.performUpdateInternal(startApproval);
      }
    },

  performUpdateInternal(startApproval) {
      this.esvLoading = true;
      let postData = lodash.cloneDeep(this.esv);

      // Convert blob URLs back to backend URLs in all rich text fields
      if (postData.updateReason) {
        postData.updateReason = this.$common.convertBlobsToBackendUrls(postData.updateReason);
      }
      if (postData.organisationComment) {
        postData.organisationComment = this.$common.convertBlobsToBackendUrls(postData.organisationComment);
      }
      if (postData.costClaimProcedure) {
        postData.costClaimProcedure = this.$common.convertBlobsToBackendUrls(postData.costClaimProcedure);
      }
      if (postData.remark) {
        postData.remark = this.$common.convertBlobsToBackendUrls(postData.remark);
      }
      
      // Convert blob URLs in phenomena and countermeasures
      postData.phenomena?.forEach(item => {
        if (item.description) {
          item.description = this.$common.convertBlobsToBackendUrls(item.description);
        }
      });
      
      postData.countermeasures?.forEach(item => {
        if (item.description) {
          item.description = this.$common.convertBlobsToBackendUrls(item.description);
        }
      });

      Object.entries(fieldConfigs).forEach(([sectionType, config]) => {
        if (config.type === 'array') {
          const items = config === fieldConfigs.phenomenon ? 
            postData.phenomena : postData.countermeasures;
          
          items?.forEach(item => {
            const fieldName = this.getFieldName(item, sectionType);
            const status = this.getFieldStatus(fieldName);
            
            if (!item.checked && startApproval) {
              item.description = '';
              if ('ratioNumber' in item) {
                item.ratioNumber = 0;
              }
            }
            item.checked = status === FieldStatus.Keep ? undefined : item.checked;
          });
        } else if (config.type === 'fields') {
          Object.entries(config.items).forEach(([fieldKey, fieldConfig]) => {
            const fieldName = this.getFieldName(fieldKey, sectionType);
            const status = this.getFieldStatus(fieldName);
            
            if (status !== FieldStatus.Keep) {
              const checked = postData[`${fieldKey}Checked`];
              if (!checked && startApproval) {
                postData[fieldKey] = fieldConfig.defaultEmpty;
              }
              postData[`${fieldKey}Checked`] = status === FieldStatus.Keep ? undefined : checked;
            }
          });
        }
      });

      // Format decimals if required
      this.formatDecimals(postData.phenomena?.toString(), ',', '.');

      // API call to save the changes
      this.$api
        .putEsvUpdate(postData, startApproval)
        .then(resp => {
          this.esv.issueDate = resp.data;
          if (startApproval) {
            this.$router.push({
              name: "ApprovalValidation",
              params: { esvId: this.id },
            });
          } else {
            this.getClaimReferences();
            // Emit successful save *only* when not navigating away immediately
            if (this.lastSaveSource === 'tab-change') {
              this.$emit('save-successful-tab-change');
            } else {
              this.$emit('save-successful');
            }
            this.lastSaveSource = null; // Reset after use
          }
        })
      .finally(() => {
          this.esvLoading = false;
          if (this.suppressToastOnce) {
            this.suppressToastOnce = false;
          } else {
            this.$toast.success("Changes have been saved");
          }
        });
    },

    //Update tables after save
    appliedModelUpdated() {
      this.getAppliedModels();
      this.getParts();
      this.getClaimReferences();
      this.getProductGroups();
    },
    //Update tables after save
    appliedModelDeleted() {
      this.getAppliedModels();
      this.getParts();
      this.getClaimReferences();
      this.getProductGroups();
    },
    appliedModelXPartsUpdated() {
      var appliedModelxPartRef = Object.assign(
        {},
        this.$refs.appliedModelxPartEdit.model
      );
      if (appliedModelxPartRef.id) {
        var index = this.sparePartsDatatable.items.findIndex(
          (x) => x.id == appliedModelxPartRef.id
        );

        this.sparePartsDatatable.items.splice(index, 1, appliedModelxPartRef);
      } else {
        this.getParts();
      }
    },

    setDefaultCCP() {
      this.$api.getDefaultCostClaimProcedure().then((resp) => {
        this.esv.costClaimProcedure = resp.data;
      });
    },
    routeToCopy() {
      var id = this.esv.id;
      this.$router.push({ name: "Copy", params: { id } });
    },

    downloadDetails() {
      this.downloadDetailsLoading = true;
      this.$api
        .downloadDetails(this.esv.id, exportTypes.pdf)
        .finally(() => (this.downloadDetailsLoading = false));
    },
    downloadModelsAndParts() {
      this.downloadModelsAndPartsLoading = true;
      this.$api
        .downloadModelsAndParts(this.esv.id, exportTypes.excel)
        .finally(() => (this.downloadModelsAndPartsLoading = false));
    },
    downloadExclusionRanges() {
      this.downloadExclusionRangesLoading = true;
      this.$api
        .downloadExclusionRanges(this.esv.id, exportTypes.excel)
        .finally(() => (this.downloadExclusionRangesLoading = false));
    },

    async selectCulture() {
      this.$store.commit("cultureUpdate", this.selectedCultureId);
      await this.init(); 
    },

    onProductGroupSelect() {
      if (this.appliedModelsXModelDatatable.search["productGroup"] && this.productGroups) {
        this.appliedModelsXModelDatatable.headerSelects["productSubGroup"] = this.productGroups.find(
          (pg) => pg.value == this.appliedModelsXModelDatatable.search["productGroup"]
        ).productSubGroups;
      }
    },

    formatDecimals(data, from, to) {
      if (data.phenomena) {
        var failureRatio = data.phenomena.filter(f => !!f.ratioNumber)[0];
        if (failureRatio && failureRatio.ratioNumber) {
          failureRatio.ratioNumber = failureRatio.ratioNumber.toString().replace(from, to);
        }
      }

    },

    sortByKey(a, b) {
      return a - b;
      // console.log(a, b);
      // return a.sortKey > b.sortKey ? -1 : 1;
    },
    
    handleApproverInput(field, value) {
      if (value === null || value === undefined || value === '') {
        this.$set(this.esv, field, 0);
      }
    },

    async processHtmlContent(content) {
      if (!content) return content;
      
      // Check cache first
      if (this.processedContent.has(content)) {
        return this.processedContent.get(content);
      }

      try {
        const processed = await convertImagesToBlobs(content);
        this.processedContent.set(content, processed);
        
        // Schedule a debounced update instead of immediate force update
        this.scheduleUpdate();
        
        return processed;
      } catch (error) {
        console.error('Error processing HTML content:', error);
        return content; // Return original content on error
      }
    },

    getProcessedContent(content) {
      if (!content) return '';
      
      // Return cached content if available
      if (this.processedContent.has(content)) {
        return this.processedContent.get(content);
      }

      // Start processing and return content with explicit loading indicators
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      
      // Replace images with loading indicators
      const images = doc.getElementsByTagName('img');
      const imagesToReplace = [];
      
      // First collect all images to replace to avoid modifying the collection while iterating
      for (let i = 0; i < images.length; i++) {
        const img = images[i];
        const src = img.getAttribute('src');
        if (src && !src.startsWith('blob:') && src.includes('/api/Images/daikin-secure/')) {
          imagesToReplace.push({
            img,
            src
          });
        }
      }
      
      // Now replace each image with a loading indicator
      imagesToReplace.forEach(({img, src}) => {
        // Create a container for the loading indicator
        const container = doc.createElement('div');
        container.className = 'image-loading-container';
        container.setAttribute('data-original-src', src);
        
        // Add a spinner SVG
        container.innerHTML = `
          <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
            <style>
              .spinner {
                animation: loader-spin 1s linear infinite;
                transform-origin: center;
              }
              @keyframes loader-spin {
                to { transform: rotate(360deg); }
              }
            </style>
            <circle class="spinner" cx="20" cy="20" r="15" fill="none" stroke="#1976d2" stroke-width="3" stroke-dasharray="75" stroke-linecap="round" />
          </svg>
          <div style="margin-top: 10px; font-size: 12px; color: #666;">Loading image...</div>
        `;
        
        // Replace the image with the loading container
        img.parentNode.replaceChild(container, img);
      });
      
      // Process the content in the background
      this.processHtmlContent(content)
        .then(() => {
          // Add a gentle force update to ensure content is displayed
          if (this.updateTimer === null) {
            this.$forceUpdate();
          }
        })
        .catch(error => {
          console.error('Error processing content:', error);
        });

      return doc.body.innerHTML;
    },
    
    prepareContentForEditor(content) {
      // If no content, return as is
      if (!content) return content;
      
      // If we already have processed content in the cache, use it
      if (content && this.processedContent.has(content)) {
        return this.processedContent.get(content);
      }
      
      // Check if content contains any backend image URLs that need processing
      const needsProcessing = content.includes('/api/Images/daikin-secure/');
      
      if (needsProcessing) {
        // Start processing in the background
        // We'll return the original content, and CKEditor's setupCKEditor will handle the conversion
        this.processHtmlContent(content)
          .catch(error => {
            console.error('Error processing content for editor:', error);
          });
      }
      
      return content;
    },
    
    // Add a debounced update method
    scheduleUpdate() {
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
      }
      
      this.updateTimer = setTimeout(() => {
        this.$forceUpdate();
        this.updateTimer = null;
      }, 100);
    },
    canEditApprover(approver, type) {
      if (this.readonly) return false

      if (type === 'issuedBy') {
        return this.esv.statusId === 1
      }

      return (
        (this.esv.statusId === 1 || this.esv.statusId === 11) &&
        !approver?.createdTs
      )
    },
   },
  computed: {
    approvedBy2Rules() {
      return [
        v => {
          if (this.esv.statusId === 11 && !v) {
            return 'ApprovedBy2 can be changed but not cleared'
          }
          return true
        }
      ]
    },
    hasAppliedModelContent() {
      return (this.appliedModelsXModelDatatable.items && this.appliedModelsXModelDatatable.items.length > 0) ||
          (this.esv.specificComplementaryConditionChecked && this.esv.specificComplementaryCondition) ||
          (this.esv.totalQuantityOfUnitsInScopeChecked && this.esv.totalQuantityOfUnitsInScope);
    },
    hasDetailOfTroubleContent() {
      return this.esv.phenomena?.some(p =>
          p.checked && (p.description || (p.type === 'Estimated Failure Ratio' && p.ratioNumber))
      );
    },
    hasCountermeasureContent() {
      return this.esv.countermeasures?.some(c =>
          c.checked && c.description
      );
    },
    hasServiceCostContent() {
      return this.esv.labourAndExpenses ||
          this.esv.servicePartsCost ||
          (this.appliedModelsDatatable.items && this.appliedModelsDatatable.items.length > 0);
    },
    sectionNumbers() {
      let counter = 1;
      const numbers = {};

      // Check each section in order and assign numbers only to visible ones
      if (this.isFieldVisible(DocumentFields.AppliedModelMfgNrs)) {
        numbers.appliedModel = counter++;
      }
      if (this.$can('Read', this.esv, 'phenomenon') && this.isFieldVisible(DocumentFields.DetailOfTrouble)) {
        numbers.detailOfTrouble = counter++;
      }
      if (this.isFieldVisible(DocumentFields.Countermeasure)) {
        numbers.countermeasure = counter++;
      }
      if (this.isFieldVisible(DocumentFields.SpareParts)) {
        numbers.spareParts = counter++;
      }
      if (this.isFieldVisible(DocumentFields.ServiceCost)) {
        numbers.serviceCost = counter++;
      }
      if (this.isFieldVisible(DocumentFields.CostClaimProcedure) && this.$can('Read', this.esv, 'costClaimProcedure')) {
        numbers.costClaimProcedure = counter++;
      }
      if (this.isFieldVisible(DocumentFields.Remark) && this.$can('Read', this.esv, 'remark')) {
        numbers.remark = counter++;
      }
      if (this.isFieldVisible(DocumentFields.SVNumbers) && this.$can('Read', this.esv, 'svNumbers')) {
        numbers.svNumbers = counter++;
      }
      if (this.isFieldVisible(DocumentFields.AppendixAndWorkInstructions) && this.$can('Read', this.esv, 'attachments')) {
        numbers.appendix = counter++;
      }

      return numbers;
    },
    DocumentFields() {
      return DocumentFields
    },
    hasDataToDelete() {
      return Object.entries(fieldConfigs).some(([sectionType, config]) => {
        if (config.type === 'array') {
          const items = config === fieldConfigs.phenomenon ?
              this.esv.phenomena : this.esv.countermeasures;

          return items?.some(item => !item.checked && this.itemHasContent(item, sectionType));
        }

        if (config.type === 'fields') {
          return Object.keys(config.items).some(fieldKey =>
              !this.esv[`${fieldKey}Checked`] && this.itemHasContent(fieldKey, sectionType)
          );
        }

        return false;
      });
    },
    filteredHeaders() {
      return this.appliedModelsXModelDatatable.headers.filter(header => {
        if (header.value === 'productNumber') {
          return this.apiCheckboxes.productNumberChecked !== null ? this.apiCheckboxes.productNumberChecked : this.isShowEnabled(DocumentFields.ProductNr);
        }
        if (header.value === 'poscode') {
          return this.apiCheckboxes.poscodeChecked !== null ? this.apiCheckboxes.poscodeChecked : this.isShowEnabled(DocumentFields.PosCode);
        }
        if (header.value === 'material') {
          return this.apiCheckboxes.materialChecked !== null ? this.apiCheckboxes.materialChecked : this.isShowEnabled(DocumentFields.Material);
        }
        if (header.value === 'serialFrom') {
          return this.apiCheckboxes.serialFromChecked !== null ? this.apiCheckboxes.serialFromChecked : this.isShowEnabled(DocumentFields.SerialNrFrom);
        }
        if (header.value === 'serialTo') {
          return this.apiCheckboxes.serialToChecked !== null ? this.apiCheckboxes.serialToChecked : this.isShowEnabled(DocumentFields.SerialNrTo);
        }
        // Always show these columns
        return header.value === 'productGroup' ||
            header.value === 'productSubGroup' ||
            header.value === 'actions';
      });
    },
    productSubGroups() {
      if (
        this.esv.productGroupId &&
        this.productGroups &&
        this.esv.productGroupId !== 0
      ) {
        var productGroup = this.productGroups.find(
          (pg) => pg.value == this.esv.productGroupId
        );
        if (productGroup) {
          return productGroup.productSubGroups;
        }
      }
      return [];
    },
    serviceRequestType() {
      if (this.esv && this.esv.serviceRequestTypeId && this.serviceRequestTypes) {
        // console.log(this.serviceRequestTypes.length);
        // console.log(this.serviceRequestTypes.find(srt => srt.value == this.esv.serviceRequestTypeId));
        let srt = this.serviceRequestTypes.find(srt => srt.value == this.esv.serviceRequestTypeId);
        return srt != undefined ? srt.text : undefined;
      }
      return undefined;
    },
    status() {
      if (this.esv && this.esv.statusId) {
        // console.log(this.statusses.find(srt => srt.value == this.esv.statusId).text);
        let status = this.statusses.find(srt => srt.value == this.esv.statusId);
        return status != undefined ? status.text : undefined;
      }
      return undefined;
    },
    serviceGrade() {
      if (this.esv && this.esv.serviceGradeId) {
        // console.log(this.serviceGrades.find(srt => srt.value == this.esv.serviceGradeId).text);
        let sg = this.serviceGrades.find(srt => srt.value == this.esv.serviceGradeId);
        return sg != undefined ? sg.text : undefined;
      }
      return undefined;
    },
    productGroup() {
      if (this.esv && this.esv.productGroupId) {
        // console.log(this.productGroups.find(srt => srt.value == this.esv.productGroupId).text);
        let pg = this.productGroups.find(srt => srt.value == this.esv.productGroupId);
        return pg != undefined ? pg.text : undefined;
      }
      return undefined;
    },
    productSubGroup() {
      if (this.esv && this.esv.productSubGroupId) {
        // console.log(this.productSubGroups.find(srt => srt.value == this.esv.productSubGroupId).text);
        let psg = this.productSubGroups.find(srt => srt.value == this.esv.productSubGroupId);
        return psg != undefined ? psg.text : undefined;
      }
      return undefined;
    },
    isApprover() {
    var userId = this.$store.state.user.name

    return this.esv.executedById == userId ||
        (this.esv.checkedById == userId && !this.esv.checkedBy?.createdTs) ||
        (this.esv.approvedBy1Id == userId && !this.esv.approvedBy1?.createdTs) ||
        (this.esv.approvedBy2Id == userId && !this.esv.approvedBy2?.createdTs);
}
  },

  watch: {
    "appliedModelsXModelDatatable.options": {
      handler() {
        this.getAppliedModelsXModels();
      },
      deep: true,
    },
    // readonly: {
    //   handler() {
    //     // if (this.readonly) {
    //       this.init();
    //     // }
    //   },
    // },
    saveCounter: {
      handler() {
        this.lastSaveSource = 'manual';
        this.putEsvUpdate();
      }
    },
    tabChangeSaveCounter: {
      handler() {
        this.lastSaveSource = 'tab-change';
        this.putEsvUpdate();
      }
    },
    reloadCounter: {
      handler() {
        this.init();
      }
    },
  },

  beforeDestroy() {
    // Clean up image URL cache when component is destroyed
    this.$common.cleanupImageUrlCache();
    
    // Clear any pending update timer
    if (this.updateTimer) {
      clearTimeout(this.updateTimer);
      this.updateTimer = null;
    }
    
    // Reset loading state
    this.editModeLoading = false;
  },
  
  deactivated() {
    // Reset loading state when component is deactivated
    this.editModeLoading = false;
  },
};
</script>

<style scoped>
.v-input--checkbox>>>label {
  color: black;
  font-size: 14px;
}

.required>>>fieldset {
  border-left: 3px solid dodgerblue;
}

.dotted>>>fieldset {
  border-left: .25rem dotted dodgerblue;
}

.hidden-content-warning {
  color: #ff4444;
  font-size: 0.875rem;
  font-style: italic;
}

.custom-total-quantity >>> label {
  color: rgb(191, 190, 190) !important; 
  font-family: "Arial", sans-serif !important;
}

:deep(img) {
  transition: filter 0.2s ease;
}

:deep(.black--text) {
  transition: background-color 0.2s ease;
}

/* Simple loading indicator class */
:deep(.image-loading-container) {
  display: inline-block;
  min-height: 100px;
  min-width: 150px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  position: relative;
  text-align: center;
  padding: 20px;
}

@keyframes loader-spin {
  to {
    transform: rotate(360deg);
  }
}

.rich-text-content {
  display: flow-root;
  width: 100%;
}

.rich-text-content::after {
  content: "";
  display: block;
  clear: both;
}

::deep(.rich-text-content img) {
  max-width: 100%;
  height: auto;
}

::deep(.rich-text-content figure) {
  max-width: 100%;
}
</style>
